import { Button, Col, Row, Tabs, Typography } from "antd";
import MakeTransition from "../../components/animator";
import React, { useMemo, useState } from "react";
import { AccountingStatementTabContent } from "../../components/reconciliation/AccountingStatementTabContent";
import { ArrearsTabContent } from "../../components/reconciliation/ArrearsTabContent";
import { NewRemittanceCard } from "../../components/reconciliation/newRemittanceTable/NewRemittanceCard";

const { Title } = Typography;

enum TabKey {
  statements = "statements",
  arrears = "arrears",
  remittance = "remittance",
}

export default function Reconciliation() {

  const [isBrokerGroupView, setisBrokerGroupView] = useState(true);
  const [isEmittedDocumentsView, setIsEmittedDocumentsView] = useState(true);
  const [activeKey, setActiveKey] = useState<TabKey>(TabKey.statements);

  const extraComponent = useMemo(() => {
    if (activeKey === TabKey.statements) {
      return (
        <Button
          type={"primary"}
          onClick={() => setisBrokerGroupView((view) => !view)}>
          {`Vedi ${isBrokerGroupView ? "titoli EC" : "lista broker"}`}
        </Button>
      );
    }
    if (activeKey === TabKey.arrears) {
      return (
        <Button
          type={"primary"}
          onClick={() => setIsEmittedDocumentsView((view) => !view)}>
          {`Vedi ${isEmittedDocumentsView ? "titoli arretrati" : "arretrati"}`}
        </Button>
      );
    }
  }, [activeKey, isBrokerGroupView, isEmittedDocumentsView]);

  return (
    <MakeTransition forwardedKey="reconciliations">
      <Row gutter={[16, 16]} style={{ padding: "1.5rem" }}>
        <Col span={24}><Title level={3}>Riconciliazione contabile</Title></Col>
        <Col span={24}>
          <Tabs
            activeKey={activeKey}
            onChange={key => {
              setisBrokerGroupView(true);
              setIsEmittedDocumentsView(true);
              setActiveKey(key as TabKey);
            }}
            tabBarExtraContent={extraComponent}
            items={[
              {
                key: TabKey.statements,
                label: "Estratti conto",
                children: <>
                  <AccountingStatementTabContent viewType={isBrokerGroupView ? "brokers" : "statementTitles"} />
                </>
              },
              {
                key: TabKey.arrears,
                label: "Arretrati",
                children: <ArrearsTabContent
                  viewType={isEmittedDocumentsView ? "arrears_documents" : "arrears_titles"} />
              },
              {
                key: TabKey.remittance,
                label: "Rimesse",
                children: <>
                  <NewRemittanceCard />
                </>
              }
            ]
            }
          />
        </Col>
      </Row>
    </MakeTransition>
  );
}